import { addSnippet } from '../../../core/snippet-manager'

/* Components =================================================================================== */
import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { Snippet, SnippetHead, SnippetBody } from '../../../modules/layouts/snippet'

/* Styles ======================================================================================= */
import { mb8 } from '../../../styles/styleset/margin/mb8'

export default addSnippet('Shortcuts', (props: any) => {
  const { title } = props

  return (
    <Snippet>
      <SnippetHead title={title} />
      <SnippetBody>
        <Box>
          <Button label="Add Purchase Order" baseline="primary" size="xs" className={mb8} float />
          <Button label="Add Daily Report" baseline="primary" size="xs" float />
        </Box>
      </SnippetBody>
    </Snippet>
  )
})
